import { render, staticRenderFns } from "./DeleteQuestionModal.vue?vue&type=template&id=5b35473b&scoped=true&"
import script from "./DeleteQuestionModal.vue?vue&type=script&lang=js&"
export * from "./DeleteQuestionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b35473b",
  null
  
)

export default component.exports